// Small notice pinned to the bottom-right after Send to Client when RingCentral delayed the texts
// (3 Nov 2026). Plain DOM so any page can call it without new state; closes itself after 20s.
export function showTextDelayNotice(data) {
  if (!data?.texts_delayed?.length) return;
  const names = data.texts_delayed.join(', ');
  const el = document.createElement('div');
  el.setAttribute('role', 'status');
  el.style.cssText = 'position:fixed;right:20px;bottom:calc(20px + env(safe-area-inset-bottom, 0px));z-index:9999;max-width:360px;background:#fff8e6;border:1px solid #f0c36d;color:#5c3d00;border-radius:10px;padding:12px 36px 12px 14px;font:14px/1.45 -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;box-shadow:0 6px 20px rgba(0,0,0,.12)';
  el.innerHTML = '<b>Email sent.</b> Texts to ' + names.replace(/[<>&]/g, '') + (data.company_name ? ' (' + String(data.company_name).replace(/[<>&]/g, '') + ')' : '') +
    ' are delayed by RingCentral and are retrying automatically. If they still fail, you\'ll get a task to resend.';
  const x = document.createElement('button');
  x.textContent = '×';
  x.setAttribute('aria-label', 'Close');
  x.style.cssText = 'position:absolute;top:6px;right:8px;border:0;background:none;font-size:18px;cursor:pointer;color:#5c3d00';
  x.onclick = () => el.remove();
  el.appendChild(x);
  document.body.appendChild(el);
  setTimeout(() => el.remove(), 20000);
}
